<template>
  <div class="Savingplan">
    <div class="title row-center" style="justify-content:space-between;">
      <div class="row-center">
        <el-date-picker
          :editable="false"
          :picker-options="pickerOptions"
          :clearable="false"
          class="dateSelect"
          v-model="date"
          :format="radio === 'week' ? 'yyyy 第 WW 周' : ''"
          :type="radio === 'day' ? 'date' : radio"
          :placeholder="new Date().toLocaleDateString().replace(/\//g, '-')"
        >
        </el-date-picker>
        <el-button plain class="btn per" @click="perM" v-if="radio === 'month'"
          >上一月</el-button
        >
        <el-button
          class="btn next"
          plain
          @click="nextM"
          v-if="radio === 'month'"
          :disabled="nextDayDisabled"
        >
          下一月
        </el-button>
      </div>
      <div class="plan" @click="dialogVisible = true">
        <img src="../../../assets/img/plan.png" alt="" />更改计划
      </div>
    </div>
    <get-plan
      :dialogVisible="dialogVisible"
      @handleClose="handleClose"
    ></get-plan>
    <div class="cont">
      <div class="plan row-center">
        <div class="item" :class="isActive==index?'active':''" v-for="(item,index) in planlist" @click="isActive=index">
          <div class="name">{{item.name}}</div>
          <div class="num" v-if="item.plan">
            <span :class="item.pross<=90?'green':item.pross>90&&item.pross<100?'yell':item.pross>=100?'red':''">{{item.real}}</span><i class="li">/</i><i>{{item.plan}}</i> {{item.unit}}
          </div>
          <div class="num" v-else>
            <span >{{item.real}} </span>{{item.unit}}
          </div>
          <el-progress
            v-if="item.plan"
            :text-inside="true"
            :stroke-width="22"
            :percentage="Number(item.pross)"
            :color="item.pross>90&&item.pross<100?'rgba(245, 170, 0, 0.3)':item.pross>=100?'rgba(253, 66, 56, 0.3)':'rgba(90, 216, 166, 0.3)'"
          ></el-progress>
          <div class="none" v-else @click="dialogVisible = true">暂未设置计划，去设置></div>
        </div>
      </div>
      <div class="Evaluation row-center">
        <div class="left">
          <div class="tt">节约用{{selectInfo.alias}}评价</div>
          <div class="line"></div>
          
          <div class="txt" style="color:#999999" v-if="selectInfo&&selectInfo.plan==''">
            暂未设置计划标准，无法评价。
          </div>
          <div class="txt" style="color:#999999" v-else-if="selectInfo.real==0">
            暂无用{{selectInfo.alias}}记录。
          </div>
          <div class="txt" v-else>
            {{month}}月计划用电{{selectInfo.plan}}{{selectInfo.unit}}，
            已用电{{selectInfo.real}}{{selectInfo.unit}}，
            <span v-if="selectInfo.pross>100">
              高于计划标准{{(selectInfo.pross-100).toFixed(2)}}%，超出用{{selectInfo.alias}}量{{(selectInfo.real-selectInfo.plan).toFixed(2)}}{{selectInfo.unit}}。
            </span>
            <span v-else>
              低于计划标准{{(100-selectInfo.pross).toFixed(2)}}%，节省用{{selectInfo.alias}}量{{(selectInfo.plan-selectInfo.real).toFixed(2)}}{{selectInfo.unit}}。
            </span>
            {{month}}月{{day}}日用电量最高，达到{{max}}{{selectInfo.unit}}，
            占总用电量的{{(max/proportion*100).toFixed(2)}}%。
            {{month}}月份用电集中时间段为12:00~13:00。
          </div>
        </div>
        <div class="img" v-if="selectInfo.plan==''||selectInfo.real==0">
          <img src="../../../assets/img/wen.png" alt=""/>
        </div>
        <div class="img" v-else>
          <img src="../../../assets/img/A.png" alt="" v-if="selectInfo.pross<=90"/>
          <img src="../../../assets/img/B.png" alt="" v-else-if="selectInfo.pross>90&&selectInfo.pross<100"/>
          <img src="../../../assets/img/C.png" alt="" v-else-if="selectInfo.pross>=100"/>
        </div>
      </div>
      <div class="charts" style="height:38vh" v-loading="monthloading">
        <charts id="Savingplan" :option="Savingplan"  v-if="!iscurveOption"></charts>
        <div  class="row-center tip" v-else style="height:100%"><img :src="require('../../../assets/img/not_found_data.png')" alt=""></div>
      </div>
    </div>
  </div>
</template>

<script>
import charts from "../../../components/Energy/charts";
import GetPlan from "../../../components/Energy/GetPlan.vue";
import { classifiedEnergyConsumption,planAndReality} from "../../../api/power";
import { floatFormat } from "../../../util/MathUtil";
import {
  perDay,
  perMonth,
  perYear,
  nextDay,
  nextMonth,
  nextYear,
  dateFormat,
  addDay,
  getAppointedDate,
} from "../../../util/DateUtil";
export default {
  components: {
    charts,
    GetPlan,
  },
  props: {
    currentLoop: Object
  },
  data() {
    return {
      pickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      date: new Date(),
      radio: "month",
      xmonth: [],
      isActive: 0,
      dialogVisible: false,
      planlist:[],
      monthData:[],
      iscurveOption:false,
      monthloading:false,
      node:"electricity",
      planData:{},
      monthCurve:[],
      proportion:0,//占比
    };
  },
  computed: {
    nextDayDisabled() {
      let timestamp = dateFormat("YY-mm-dd", new Date());
      let endtime = dateFormat("YY-mm-dd", this.date);
      if (this.radio === "year") {
        timestamp = dateFormat("YY", new Date());
        endtime = dateFormat("YY", this.date);
      } else if (this.radio === "month") {
        timestamp = dateFormat("YY-mm", new Date());
        endtime = dateFormat("YY-mm", this.date);
      } else if (this.radio === "week") {
        timestamp = dateFormat("YY-mm-dd", new Date());
        endtime = dateFormat("YY-mm-dd", addDay(this.date, 5));
      }
      if (endtime >= timestamp) {
        return true;
      } else {
        return false;
      }
    },
    Savingplan(){
      return {
        title: {
          text: "月累计用电",
          left: "center",
          textStyle: {
            color: "#999999",
            fontSize: "16rem",
            fontWeight: 400,
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line",
          },
        },
        color: ["#dffdf2", "#fdebc5", "#fdd4d2", "#0D94FF"],
        xAxis: {
          nameLocation: "center",
          type: "category",
          boundaryGap: true,
          data: this.xmonth,
          show: true,
          axisTick: {
            show: true,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#CCCCCC",
              width: 1,
              type: "solid",
            },
          },
          axisLabel: {
            //x轴文字的配置
            show: true,
            textStyle: {
              color: "#999999",
            },
          },
        },
        grid: {
          top: "10%",
          left: "3%",
          right: "3%",
          bottom: "5%",
          containLabel: true,
        },
        yAxis: {
          name: this.selectInfo.unit,
          type: "value",
          // max:this.planlist[this.isActive].pross>100?"":this.planlist[this.isActive].plan,
          max: (value) => {
            if(this.planlist[this.isActive].plan){
              if(this.planlist[this.isActive].pross>100){
                // return Math.ceil(this.planlist[this.isActive].real)
                return null
              }else{
                return this.planlist[this.isActive].plan*1.2
              }
            }else{
              return null
            }
            
          },
          scale:true,
          axisLabel: {
            formatter: "{value}",
          },
        },

        series: [
          {
            name: "低故障率",
            type: "line",
            animation: false,
            areaStyle: {
              normal: {},
            },
            lineStyle: {
              normal: {
                width: 1,
              },
            },
            markArea: {
              data: [
                [
                  {
                    yAxis: "0",
                  },  
                  {
                    yAxis:this.planlist[this.isActive].plan*0.9,
                  },
                ],
              ],
            },
          },
          {
            name: "中等故障率",
            type: "line",
            animation: false,
            areaStyle: {
              normal: {},
            },
            lineStyle: {
              normal: {
                width: 1,
              },
            },
            markArea: {
              data: [
                [
                  {
                    yAxis: this.planlist[this.isActive].plan*0.9,
                  },
                  {
                    yAxis: this.planlist[this.isActive].plan,
                  },
                ],
              ],
            },
          },
          {
            name: "高故障率",
            type: "line",
            animation: false,
            areaStyle: {
              normal: {},
            },
            lineStyle: {
              normal: {
                width: 1,
              },
            },
            markArea: {
              data: [
                [
                  {
                    yAxis: this.planlist[this.isActive].plan,
                  },
                  {
                    yAxis: this.planlist[this.isActive].pross>100?this.planlist[this.isActive].real*1.2:this.planlist[this.isActive].plan*1.2,
                  },
                ],
              ],
            },
          },
          {
            name: "月累计用电",
            type: "line",
            data: this.monthData
          },
        ],
      };
    },
    propsData(){
      return [this.date,this.isActive,this.currentLoop]
    },
    selectInfo(){
      return this.planlist[this.isActive]
    },
    max(){
      if(this.monthCurve.length>0){
        return floatFormat(Math.max(...this.monthCurve), 2)
      }else{
        return ''
      }
    },
    month(){
      return dateFormat("mm", this.date)
    },
    day(){
      let index = this.monthCurve.findIndex((item) => item == Math.max(...this.monthCurve))
      return this.xmonth[index]
    },
  },
  watch: {
    propsData(){
      this.node = this.getnode();
      this.getLoopData();
      this.GetPlan();
    },
    dialogVisible(n,o){
      if(!n){
        this.GetPlan();
      }
    }
  },
  mounted() {
    for (let i = 1; i <= 31; i++) {
      this.xmonth.push(i);
    }
    this.GetPlan();
    this.getLoopData();
  },
  methods: {
    //计划与实际
    async GetPlan() {
      let obj = {
          date:dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
          buildingIds : this.currentLoop.id,
          projectId: this.$store.state.project.currentProject.projectId,
      };
      let response = await planAndReality(obj);
      let list = response.data.data.list[0];
      let map = [
          {title:"电",unit:"kWh",name:"electric"},
          {title:"水",unit:"m³",name:"water"},
          {title:"热",unit:"GJ",name:"heat"},
          {title:"冷",unit:"GJ",name:"cooling"},
        ]
        this.planlist = []
        map.forEach((item,index) => {
          if(index==0){
             this.planlist.push({
              name:"用电计划",
              alias:"电",
              real:list.reality.power.toFixed(2),
              plan:list.plan&&list.plan.electric?list.plan.electric.toFixed(2):"",
              unit:"kWh",
              pross:list.plan&&list.plan.electric?Number(list.reality.power/list.plan.electric*100).toFixed(2):0
            })
          }else{
            this.planlist.push({
              name:"用"+item.title+"计划",
              alias:item.title,
              real:list.reality[item.name].toFixed(2),
              plan:list.plan&&list.plan[item.name]?list.plan[item.name].toFixed(2):"",
              unit:item.unit,
              pross:list.plan&&list.plan[item.name]?Number(list.reality[item.name]/list.plan[item.name]*100).toFixed(2):0
            })
          }
          
        });
    },
    getnode(){
      switch (this.isActive) {
        case 0:
          return "electricity"
          break;
        case 1:
          return "water"
          break;
        case 2:
          return "heat"
          break;
        case 3:
          return "cooling"
          break;
      }
    },
    //月能耗曲线
    async getLoopData(){
      this.monthloading = true
      let obj = {
          date:dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
          powerType:this.node.toUpperCase(),
          buildingId:this.currentLoop.id,
          range:"MONTH"
        }
      let response = await classifiedEnergyConsumption(obj);
      let list = response.data.data.result[this.node].map(e=>e!=null?e.toFixed(2):'') || [];
      this.monthCurve = list
      let len = list.filter(e=>e!=null&&e!="")
      if(len.length>0){
        this.iscurveOption = false
      }else{
        this.iscurveOption = true
      }
      let data = []
      let total = 0
      //累加
      for (let index = 0; index < list.length; index++) {
        total+=Number(list[index])
        let element = 0
        if(index==0){
          element = Number(list[index])
        }else{
          element = Number(data[index-1])+Number(list[index]);
        }
        data.push(element.toFixed(2))
      }
      this.proportion = total
      this.monthData = data
      this.monthloading = false
    },
    handleClose() {
      this.dialogVisible = false;
    },
    perW() {
      let week = getAppointedDate(this.date, 1, 1);
      this.date = new Date(week.startDate);
    },
    nextW() {
      let week = getAppointedDate(this.date, 1, -1);
      this.date = new Date(week.startDate);
    },
    perD() {
      this.date = perDay(this.date);
    },
    nextD() {
      this.date = nextDay(this.date);
    },
    perM() {
      this.date = perMonth(this.date);
    },
    nextM() {
      this.date = nextMonth(this.date);
    },
    perY() {
      this.date = perYear(this.date);
    },
    nextY() {
      this.date = nextYear(this.date);
    },
  },
};
</script>

<style scoped lang="less">

.Evaluation {
  justify-content: space-between;
  padding: 3vh 3vw;
  height: 28vh;
  .left {
    width: 50%;
  }
  .img {
    width: 50%;
    text-align: center;
    img {
      width: 22vh;
    }
  }
  .line {
    width: 40px;
    height: 4px;
    background: #333333;
  }
  .tt {
    font-size: 30px;
    font-weight: bold;
  }
  .txt {
    font-size: 18rem;
    font-weight: 400;
    margin-top: 25rem;
    line-height: 30rem;
  }
}
/deep/.el-progress-bar__outer {
  background-color: rgba(0, 43, 102, 0.08);
}
/deep/.el-progress-bar__inner {
  text-align: left !important;
}

/deep/.el-progress-bar__innerText {
  color: #333;
}
.tabs-container {
  display: flex;
  flex-direction: row;
  justify-content: space-left;
  height: 4.5vh;
  span {
    line-height: 60rem;
    border-top: 2px solid #fff;
    font-size: 18rem;
    font-weight: 400;
    margin: 0 10rem;
    cursor: pointer;
    font-weight: bold;
  }
  .active {
    color: #0d94ff;
    border-top: 2px solid #0d94ff;
  }
}
.Savingplan {
  height: 100%;
  font-size: 18rem;
  background: #ffffff;
}
.title {
  background: #ffffff;
  height: 8vh;
  padding: 0 30rem;
  width: 100%;
  .demonstration {
    margin-right: 10rem;
  }
  .block {
    margin-right: 80rem;
  }
  .dateSelect {
    margin-right: 10rem;
  }
  .per {
    margin-left: 10rem;
  }
  .el-radio {
    margin-right: 20rem;
  }
  .plan {
    border: 1px solid #cccccc;
    border-radius: 4rem;
    color: #666666;
    height: 40px;
    font-size: 16rem;
    cursor: pointer;
    line-height: 40px;
    padding: 0 15px;
    .btn {
      height: 40px;
      line-height: 40px;
      padding: 0 15px;
    }
    img {
      width: 22rem;
      margin-right: 3rem;
      vertical-align: -5px;
    }
  }
}
.cont {
  .plan {
    justify-content: space-between;
    padding: 0 30rem;
    font-size: 18rem;
    font-weight: bold;
    .item {
      
    cursor: pointer;
      width: 15.2vw;
      height: 15.5vh;
      background: rgba(0, 43, 102, 0.04);
      border-radius: 24rem;
      padding: 20rem;
      .name {
        font-size: 18rem;
        font-weight: bold;
      }
      .none{
        color: #0D94FF;
        font-size: 16rem;
      }
      .num {
        margin-top: 2vh;
        margin-bottom: 8rem;
        span {
          font-size: 30rem;
          color: #000;
        }
        .green{
          color: #5ad8a6;
        }
        .red{
          color: #FD4238;
        }
        .yell{
          color: #F5AA00;
        }
        i {
          font-style: initial;
        }
        .li {
          font-size: 30rem;
        }
      }
    }
    
    .active {
      background: #ffffff;
      box-shadow: 4px 7px 30px 0px rgba(13, 148, 255, 0.24);
    }
  }
}
</style>
